<template>
   <!-- <b-navbar type="dark" variant="dark"> -->
        <div  v-if="isMobile() || isOK == true" >
            <vnavbar></vnavbar>
        </div>
        <b-navbar v-else type="dark" variant="dark">
            <b-navbar-nav >
                <Vendedoritems/>
                
                <RCIitems/>
                <Preprensaitems/>
                <Ingenieriaitems/>
                <Bitacoraitems/>
                <Reportesitems/> 
                <Googleitems/>
                <Ticketsitems/>
                <TicketsMantenimiento/>
                <Adminitems/>
                
                <b-nav-item @click="_logout"> Cerrar sessión </b-nav-item>    
                </b-navbar-nav>
        </b-navbar>
</template>

<script>
    import {mapMutations,mapState,mapActions} from 'vuex'
    import Adminitems from '@/components/navigations/Admin'
    import Vendedoritems from '@/components/navigations/Vendedor'
    import Preprensaitems from '@/components/navigations/Preprensa'
    import Ingenieriaitems from '@/components/navigations/Ingenieria'
    import Bitacoraitems from '@/components/navigations/Bitacora'
    import Googleitems from '@/components/navigations/Google'
    import RCIitems from '@/components/navigations/DatosRCI'
    import customMixin from '@/mixins/customMixin'
    import vnavbar from '@/components/partials/vnavbar'
    import Reportesitems from '@/components/navigations/Reportes'
    import Ticketsitems from '@/components/navigations/Tickets'
    import TicketsMantenimiento from '@/components/navigations/TicketsMantenimiento'
    
    export default {
        mixins : [customMixin],
        components:{
           Vendedoritems, Adminitems, Preprensaitems, Ingenieriaitems, Bitacoraitems, Googleitems, RCIitems,
           vnavbar, Reportesitems, Ticketsitems,TicketsMantenimiento
        },
        data: function(){
            return {
                isOK: false
            }
        },
        mounted(){
            this.init()
        },
        computed:{
            ...mapState('login',['rol_id']),
            ...mapState('permiso',['permiso']), 
        },
        methods:{
            ...mapMutations('login',['logout']),
            ...mapActions({
                _fetchPermisos: 'permiso/fetchPermisosUsuarios',
            }),
            _logout(){
                this.logout()
                this.$router.push('/login')
            },
            isMobile() {
                if( screen.width <= 760 ) {
                    return true;
                }
                else {
                    return false;
                }
            },
            init(){
                this._fetchPermisos(this.rol_id).then(() => {  
                    this.isOK =  this.isAdmin(this.permiso) 
                })
            },


        }
    }
</script>

<style lang="scss" scoped>


</style>